/*
  Default product template (PDP) mobile gallery reset.

  Ported unchanged from the Control path of the concluded VWO "Product Page Test"
  (the retired arm script, now under archive/experiments/pdp-product-page-test-2026-07/).
  In that script scheduleMobileGalleryReset() ran before the V1 early return, so it
  was Control behaviour and survives the experiment's conclusion.

  Dawn's GalleryViewer can come up on the wrong page (and with a stale active
  thumbnail) on mobile; this re-seeds it to the first slide, but only until the
  visitor has used the slider arrows themselves.
*/
(function () {
  var pdpGalleryState = new WeakMap();
  var previousViewportIsMobile = isMobileViewport();

  function isMobileViewport() {
    return window.innerWidth < 750;
  }

  function getRootGalleryState(root) {
    var state = pdpGalleryState.get(root);
    if (!state) {
      state = {
        initialized: false,
        interacted: false,
        bound: false
      };
      pdpGalleryState.set(root, state);
    }
    return state;
  }

  function bindGalleryInteractionLock(root, state) {
    if (state.bound) return;
    state.bound = true;

    root.querySelectorAll('media-gallery .slider-button--next, media-gallery .slider-button--prev').forEach(function (button) {
      button.addEventListener('click', function () {
        state.interacted = true;
      });
    });
  }

  function resetMobileGalleryPages(root) {
    if (!isMobileViewport()) return;
    var state = getRootGalleryState(root);
    bindGalleryInteractionLock(root, state);
    var forceFirstPage = !state.interacted;

    root.querySelectorAll('media-gallery').forEach(function (mediaGallery) {
      var viewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer || typeof viewer.resetPages !== 'function') return;

      viewer.resetPages();

      // Dawn's SliderComponent.initPages() (assets/global.js) abandons setup when
      // fewer than two slides are measurable - it returns BEFORE its own update()
      // call, leaving sliderItemsToShow empty and sliderItemOffset undefined.
      // Driving update() ourselves in that state makes it evaluate
      // isSlideVisible(sliderItemsToShow[0]) and isSlideVisible(sliderItemsToShow[-1]),
      // both undefined, and isSlideVisible() reads element.offsetLeft straight away -
      // "Cannot read properties of undefined (reading 'offsetLeft')".
      //
      // Respect Dawn's own invariant instead: with fewer than two visible slides
      // there are no pages, so there is no page state to reset. The rAF pass can
      // legitimately land before the gallery is laid out (nothing measurable yet);
      // the 150ms pass then does the real work. The archived experiment script had
      // this identical latent path - it simply never surfaced on live, where the
      // gallery is already laid out by the time the first pass runs.
      if (!viewer.sliderItemsToShow || viewer.sliderItemsToShow.length < 2) return;

      if (viewer.slidesPerPage === undefined || viewer.slidesPerPage < 1) {
        viewer.slidesPerPage = 1;
        viewer.totalPages = viewer.sliderItemsToShow.length;
      }

      if (forceFirstPage && !state.initialized) {
        state.initialized = true;
        if (viewer.sliderItemsToShow && viewer.sliderItemsToShow[0] && viewer.slider) {
          if (typeof viewer.slider.scrollTo === 'function') {
            viewer.slider.scrollTo({ left: viewer.sliderItemsToShow[0].offsetLeft });
          } else {
            viewer.slider.scrollLeft = viewer.sliderItemsToShow[0].offsetLeft;
          }
        }
      }

      if (typeof viewer.update === 'function') viewer.update();

      if (forceFirstPage) {
        viewer.currentPage = 1;
        if (typeof viewer.update === 'function') viewer.update();
      } else if (viewer.sliderItemsToShow && viewer.sliderItemsToShow.length > 0) {
        var currentPage = Number(viewer.currentPage) || 1;
        if (currentPage < 1) currentPage = 1;
        if (currentPage > viewer.sliderItemsToShow.length) currentPage = viewer.sliderItemsToShow.length;
        viewer.currentPage = currentPage;
      }

      if (!mediaGallery.elements || !mediaGallery.elements.thumbnails) return;

      var activeIndex = forceFirstPage ? 0 : (Number(viewer.currentPage) - 1);
      var currentSlide = viewer.sliderItemsToShow && viewer.sliderItemsToShow[activeIndex];
      if (!currentSlide && viewer.sliderItemsToShow && viewer.sliderItemsToShow.length > 0) {
        currentSlide = viewer.sliderItemsToShow[0];
      }
      if (!currentSlide || !currentSlide.dataset.mediaId || typeof mediaGallery.setActiveThumbnail !== 'function') return;
      var currentThumbnail = mediaGallery.elements.thumbnails.querySelector('[data-target="' + currentSlide.dataset.mediaId + '"]');
      mediaGallery.setActiveThumbnail(currentThumbnail);
    });
  }

  function scheduleMobileGalleryReset(root) {
    if (!isMobileViewport()) return;

    window.requestAnimationFrame(function () {
      resetMobileGalleryPages(root);
    });

    window.setTimeout(function () {
      resetMobileGalleryPages(root);
    }, 150);
  }

  function applyGalleryReset(root) {
    if (root.getAttribute('data-pdp-default-template') !== 'true') return;
    scheduleMobileGalleryReset(root);
  }

  function syncAll() {
    document.querySelectorAll('[data-pdp-root][data-pdp-default-template="true"]').forEach(applyGalleryReset);
  }

  var resizeTimer;

  function handleResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      var isMobileNow = isMobileViewport();
      if (isMobileNow === previousViewportIsMobile) return;
      previousViewportIsMobile = isMobileNow;
      syncAll();
    }, 150);
  }

  function start() {
    syncAll();
    window.addEventListener('resize', handleResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
